module.exports = __webpack_public_path__ + "static/media/phillipSearcher.7c7f5c4c.png";